module.exports = __webpack_public_path__ + "img/couples-052.27e9a932.jpg";